var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"flat":!_vm.copied,"color":_vm.copied ? 'green' : 'grey',"disabled":_vm.playlistModalLoading},on:{"click":function($event){return _vm.copy(_vm.copyText)}}},[(!_vm.copied)?_c('span',[_vm._v("Copy")]):_c('span',{staticClass:"white--text"},[_vm._v("Copied")])])
}
var staticRenderFns = []

export { render, staticRenderFns }